import type { SelectFieldOption } from '#layers/block-engine/public';

/** Default API key time-to-live, shared by the create dialog and connect flows. */
export const DEFAULT_TTL = '30 days';

/**
 * Selectable API key lifetimes. Labels use the `$t:` convention so the select
 * normalizes and translates them at render time.
 */
export const TTL_OPTIONS = [
	{ value: '7 days', label: '$t:api_keys.ttl_7_days' },
	{ value: DEFAULT_TTL, label: '$t:api_keys.ttl_30_days' },
	{ value: '60 days', label: '$t:api_keys.ttl_60_days' },
	{ value: '90 days', label: '$t:api_keys.ttl_90_days' },
	{ value: '1 year', label: '$t:api_keys.ttl_1_year' },
	{ value: null, label: '$t:expiry.never' },
] satisfies SelectFieldOption[];
